module.exports = __webpack_public_path__ + "static/media/binance.212818df.svg";